/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { ReplyWarning } from '@modules/cloud-api/v1/types'
import type { AsyncRequestState } from '@modules/ui-types'

import { getValidationWarnings } from '../../lib/dryRunWarnings'

import type { ReactElement, FunctionComponent } from 'react'

type Props = {
  updateDeploymentDryRunRequest: AsyncRequestState
  children: (params: { dryRunWarnings: ReplyWarning[]; dryRunCheckPassed: boolean }) => ReactElement
}

const StackDeploymentUpdateDryRunWarningCheck: FunctionComponent<Props> = ({
  updateDeploymentDryRunRequest,
  children,
}) => {
  const dryRunCheckPassed = passedDryRunCheck({
    updateDeploymentDryRunRequest,
  })

  const dryRunWarnings = getValidationWarnings({
    updateDeploymentDryRunRequest,
  })

  return children({ dryRunWarnings, dryRunCheckPassed })
}

export default StackDeploymentUpdateDryRunWarningCheck

function passedDryRunCheck({
  updateDeploymentDryRunRequest,
}: {
  updateDeploymentDryRunRequest: AsyncRequestState
}): boolean {
  if (updateDeploymentDryRunRequest.inProgress) {
    return false
  }

  if (updateDeploymentDryRunRequest.error) {
    return false
  }

  return true
}
